export const navState = [

    {
        id: 1,
        title: "DashBoard",
        isActive: true,
        iconUrl: ["./assets/images/active_dashboard_icon.svg", "./assets/images/inactive_dashboard_icon.svg", "./assets/images/active_sm_dashboard_icon.svg"],
        route: "/dashboard"
    },
    {
        id: 2,
        title: "Explore",
        isActive: false,
        iconUrl: ["./assets/images/active_explore_icon.svg", "./assets/images/inactive_explore_icon.svg", "./assets/images/active_sm_explore_icon.svg"],
        route: "/explore"
    },
    {
        id: 3,
        title: "My Learning",
        isActive: false,
        iconUrl: ["./assets/images/active_my_learning_icon.svg", "./assets/images/inactive_my_learning_icon.svg", "./assets/images/active_sm_my_learning_icon.svg"],
        route: "/mylearning"
    },
    {
        id: 4,
        title: "Settings",
        isActive: false,
        iconUrl: ["./assets/images/active_settings_icon.svg", "./assets/images/inactive_settings_icon.svg", "./assets/images/active_sm_settings_icon.svg"],
        route: "/settings"
    },
    
]